export default __webpack_public_path__ + "assets/minespace-landing-bg.a0758951.jpg";